<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>
    <!-- Top Banner Section Start -->
    <div class="flex-grow">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/faq-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">Frequently Asked Questions</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->
        
        <!-- FAQ Section Start -->
        <section class="faq-sec mt-[120px] p-6 xxl:p-0 pt-0 pb-[70px] md:pb-[100px]">
          <div class="container mx-auto">
              <div class="grid grid-cols-12 gap-8 items-center">
                  <div class="col-span-12 lg:col-span-5">
                      <div class="faq-title">
                          <div class="faq-img text-center">
                          <img src="/assets/images/faq/faq-2.png" alt="" class="w-[100%] h-[500px] lg:h-[650px] object-cover rounded-[15px]">
                          </div>
                      </div>
                  </div>
                  <div class="col-span-12 lg:col-span-6 mt-[2em] md:mt-0 lg:ml-[100px]">
                      <div class="faq-title">
                          <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">FAQ</span>
                          <h3 class="title mt-0 mb-[20px] font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] max-w-[640px] leading-[1.2em]">
                              We Provide Best Frequency And Questions</h3>
                      </div>
                      <p class="max-w-[90%]">
                        In our FAQ section, we’ve gathered the most commonly asked questions to provide you with quick and clear answers. Whether you're curious about how to book an appointment, consult a doctor online, or manage your account, our FAQs are here to help. We’re committed to making your experience with Medease Stay at Home as smooth and straightforward as possible.
                      </p>
                      <div class="faq-content mt-[2em]">
                        <mat-accordion>
                            <!-- <mat-expansion-panel hideToggle>
                              <mat-expansion-panel-header>
                                <mat-panel-title> This is the expansion title </mat-panel-title>
                                <mat-panel-description> This is a summary of the content </mat-panel-description>
                              </mat-expansion-panel-header>
                              <p>This is the primary content of the panel.</p>
                            </mat-expansion-panel> -->
                            <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)">
                              <mat-expansion-panel-header class="faq-head">
                                <mat-panel-title class="faq-title"> What is Medease?</mat-panel-title>
                              </mat-expansion-panel-header>
                              <p>
                                Medease is an online healthcare platform that allows patients to easily search for doctors, book appointments, and manage healthcare services. It provides access to various specialists across multiple hospitals and branches, streamlining the appointment booking process.
                              </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)">
                              <mat-expansion-panel-header>
                                <mat-panel-title class="faq-title">How do I register on Medease?</mat-panel-title>
                              </mat-expansion-panel-header>
                              <p>
                                Click on the 'Sign Up' button at the top of the homepage.
                                Provide your personal information such as name, phone number, and email address.
                                Create a secure password.
                                You will receive a verification email to confirm your registration. Once verified, you can log in and start booking appointments.
                                                            </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)">
                              <mat-expansion-panel-header>
                                <mat-panel-title class="faq-title">How can I book an appointment with a doctor?</mat-panel-title>
                              </mat-expansion-panel-header>
                              <p>
                                Log in to your account.
                                Use the search function to find doctors by specialty, location, or hospital.
                                Select your preferred doctor and view available time slots.
                                Choose a convenient date and time, and confirm the booking.
                                You will receive a confirmation message with your appointment details.
                              </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel [expanded]="step() === 3" (opened)="setStep(3)">
                              <mat-expansion-panel-header>
                                <mat-panel-title class="faq-title">Can I book an appointment without an account?</mat-panel-title>
                              </mat-expansion-panel-header>
                              <p>
                                No, you need to have an account to book appointments. Creating an account allows you to track your appointments, access your medical history, and receive notifications.
                              </p>
                            </mat-expansion-panel>
                            <mat-expansion-panel [expanded]="step() === 4" (opened)="setStep(4)">
                              <mat-expansion-panel-header>
                                <mat-panel-title class="faq-title">How do I reschedule or cancel an appointment?</mat-panel-title>
                              </mat-expansion-panel-header>
                              <p>
                                Log in to your account and go to the 'My Bookings' section.
                                Select the appointment you wish to modify.
                                Choose the 'Reschedule' option to pick a new date/time, or 'Cancel' to cancel your booking.
                                Please note that certain doctors may have cancellation policies, and fees may apply if you cancel late.
                              </p>
                            </mat-expansion-panel>
                          </mat-accordion>
                    </div>
                  </div>
              </div>
          </div>
      </section>
        <!-- FAQ Section End -->
    </div>

    <!-- Footer  -->
    <app-message></app-message>
    <app-footer></app-footer>
</div>